import { Component } from '@angular/core';

@Component({
  selector: 'grapes-icon',
  standalone: true,
  imports: [],
  templateUrl: './grapes.component.html',
  styleUrl: './grapes.component.scss'
})
export class GrapesIcon {

}
